import { getChannelsByType } from '@com/utils/channel'

export default function parseTraffic(status) {
  const channelList = getChannelsByType()
  const filteredChannel = channelList.filter(
    (item) => Number(item.value) === Number(status),
  )
  if (filteredChannel.length > 0) return filteredChannel[0].label
  return '-'
}
